<template>
    <section id="cloud_technologies_content">

        <div class="container">

            <div class="row" id="first_row">

                <!-- In Small Screen -->
                <nav aria-label="breadcrumb" class="mt-4 d-block d-lg-none">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">
                            <router-link :to="{ name: 'cloud_technologies' }" class="text-reset">التقنيات السحابية والذكاء الإصطناعي</router-link>
                        </li>
                    </ol>
                </nav>

                <div class="col-12 col-lg-6 mt-3 mt-lg-4 order-2 order-lg-1">

                    <div class="col_one_content d-flex flex-column justify-content-start w-100 h-100">

                        <nav aria-label="breadcrumb" class="d-none d-lg-block">
                            <ol class="breadcrumb mb-0">
                                <li class="breadcrumb-item">
                                    <router-link :to="{ name: 'service' }" class="text-reset">الخدمات</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <router-link :to="{ name: 'cloud_technologies' }" class="text-reset">التقنيات السحابية والذكاء الإصطناعي</router-link>
                                </li>
                            </ol>
                        </nav>

                        <p>تقديم الخدمات الاستشارية وتطوير منظومة التحول الرقمي والمنصات الالكترونية والذكاء الاصطناعي.</p>

                        <h5 class="mt-3">كيف تعمل الحوسبة السحابية؟</h5>

                        <p>التقنية الأساسية التي تعمل عليها السحابة هي المحاكاة الافتراضية، أو الـVirtualization. المحاكاة الافتراضية تسمح للحاسوب بخلق جهاز رقمي افتراضي غير موجود فعليًا، لكنه يتصرف كأنه جهاز حقيقي. هذه التقنية تمكنك من تنصيب أكثر من حاسوب على جهاز واحد. كل هذه الحواسيب الافتراضية تعمل بنفس الوقت، لكن بالرغم من أنها تتشارك نفس المعالج والقرص الصلب، الا انه لا يمكنه التواصل مع بعضها البعض. أي أن الملفات الموجودة على جهاز افتراضي ما لا يمكن الوصول إليها عبر جهاز افتراضي آخر. عبر استخدام تقنية المحاكاة الافتراضية، يمكننا أن نعتبر ان السيرفر الواحد أصبح يمثل عدّة سيرفرات، مما يسمح للشركات التي تقدم خدمات حوسبة سحابية بالتعامل مع عدد أكبر من المستخدمين. بالعادة، تقوم هذه الشركات أيضًا بعمل نسخ احتياطية من ملفاتك ووضعها على أكثر من جهاز بمناطق مختلفة، تحسبًا من تعطل أحد الأجهزة.</p>

                    </div>

                </div>

                <div
                    class="col-12 col-lg-6 mt-3 mt-lg-4 d-flex justify-content-center align-items-start order-1 order-lg-2">

                    <div class="col_two_content">
                        <div class="img_wrapper">
                            <img src="@/assets/images/services/cloud_technologies_img.webp" alt="">
                        </div>
                    </div>

                </div>

            </div>

            <div class="row" id="second_row">

                <h5 class="mt-3 mb-0">ما هي نماذج الخدمة الرئيسية للحوسبة السحابية؟</h5>

                <div class="col-12 col-lg-6 mt-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>SaaS - Software As Service</li>
                        </ul>

                        <p>نقوم بتقديم البرامج لك كخدمة. فبدلًا من تحميل البرامج على جهازك، يمكنك الوصول إليها عبر الإنترنت.حيث ان Google Docs هو مثال عن احد هذه البرامج. Slack، برنامج الشات المخصص للشركات هو مثال آخر.</p>

                    </div>

                </div>

                <div class="col-12 col-lg-6 mt-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>PaaS - Platform As Service</li>
                        </ul>

                        <p>في هذا النموذج، نقوم بتقديم خدمات تمكنك من بناء منصّتك الخاصة، كموقع مثلا. حيث نهيء لك السيرفرات والأدوات المناسبة لبناء منصّتك ،بدون أن تقلق وتهتم بأمور مثل صيانة الأجهزة وتحديث الأدوات.</p>

                    </div>

                </div>

                <div class="col-12 col-lg-6 mt-3 mb-3">

                    <div class="col_three_content w-100 h-100 p-3">

                        <ul class="mb-1">
                            <li>IAS - Infrastructure As Service</li>
                        </ul>

                        <p>هذا النموذج هو عبارة عن إعطاءك إمكانية استخدام سيرفرات الشركة، ولكنها لا تقدم لك الأدوات اللازمة. الموضوع أشبه باستئجار مبنى او مكتب لشركتك. صاحب العقار لن يقوم بترتيب مكتبك وتجهيزه بالمعدات اللازمة.</p>

                    </div>

                </div>

            </div>



        </div>

    </section>
</template>

<script>
export default {
    name: 'CloudTechnologies',
}
</script>

<style lang="scss" scoped>
#cloud_technologies_content {

    min-height: 100vh;

    margin-top: 72px;

    @include breakpoints(x-small) {
        margin-top: 86px;
    }

    @include breakpoints(small) {
        margin-top: 86px;
    }

    @include breakpoints(medium) {
        margin-top: 86px;
    }

    .container {

        #first_row {

            nav {
                .breadcrumb {

                    li:first-of-type {
                        font-size: 16px;
                        line-height: 180%;
                        background: $Linear-Blue;
                        background-clip: text;
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }

                    li:nth-of-type(2n) {
                        font-family: 'FFShamelFamily-Bold';
                        font-size: 18px;
                        line-height: 180%;
                        color: $Green;
                    }

                }

                .breadcrumb-item::before {
                    float: right;
                    margin-left: 8px;
                    background: $Linear-Blue;
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
            }

            .col_one_content {

                p {
                    color: $White;
                    font-size: 16px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;

                    @include breakpoints(large) {
                        font-size: 13px;
                    }

                    @include breakpoints(x-Large) {
                        font-size: 14px;
                    }
                }

                h5 {
                    font-family: 'FFShamelFamily-Bold';
                    font-size: 16px;
                    line-height: 156%;
                    color: $Green;

                    @include breakpoints(large) {
                        font-size: 14px;
                    }

                    @include breakpoints(x-Large) {
                        font-size: 14px;
                    }
                }

            }

            // https://stackoverflow.com/questions/31854185/how-to-add-border-in-my-clip-path-polygon-css-style
            .col_two_content {

                position: relative;

                width: 636px;
                height: 426px;

                @include breakpoints(x-small) {
                    width: 351px;
                    height: 235px;
                }

                @include breakpoints(small) {
                    width: 516px;
                    height: 345px;
                }

                @include breakpoints(medium) {
                    width: 696px;
                    height: 466px;
                }

                @include breakpoints(large) {
                    width: 456px;
                    height: 305px;
                }

                @include breakpoints(x-Large) {
                    width: 546px;
                    height: 366px;
                }

                background: $Green;
                box-sizing: border-box;

                // https://www.cssportal.com/css-clip-path-generator/
                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                .img_wrapper {

                    position: absolute;
                    top: 1px;
                    left: 1px;

                    width: 634px;
                    height: 424px;

                    @include breakpoints(x-small) {
                        width: 349px;
                        height: 233px;
                    }

                    @include breakpoints(small) {
                        width: 514px;
                        height: 343px;
                    }

                    @include breakpoints(medium) {
                        width: 694px;
                        height: 464px;
                    }

                    @include breakpoints(large) {
                        width: 454px;
                        height: 303px;
                    }

                    @include breakpoints(x-Large) {
                        width: 544px;
                        height: 364px;
                    }

                    // https://www.cssportal.com/css-clip-path-generator/
                    // CSS Vendor Prefixes
                    -webkit-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -moz-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -o-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    -ms-clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);
                    clip-path: polygon(0% 3%, 0% 3%, 3% 0%, 3% 0%, 97% 0%, 97% 0%, 100% 3%, 100% 3%, 100% 80%, 100% 80%, 97% 85%, 97% 85%, 90% 85%, 90% 85%, 77% 100%, 77% 100%, 3% 100%, 3% 100%, 0% 97%, 0% 97%);

                    // border: solid 2px $Green;

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        opacity: 0.9;
                    }

                    img:hover {
                        opacity: 1;
                        -webkit-transition: opacity 0.5s linear 0.2s;
                        -moz-transition: opacity 0.5s linear 0.2s;
                        transition: opacity 0.5s linear 0.2s;
                    }

                }

            }

        }

        #second_row {

            h5 {

                font-family: 'FFShamelFamily-Bold';
                font-size: 16px;
                line-height: 156%;
                color: $Yellow;
            }

            .col_three_content {

                background: $Dark-Green;

                // CSS Vendor Prefixes
                -webkit-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -moz-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -o-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                -ms-clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);
                clip-path: polygon(0% 3%, 0% 3%, 0% 80%, 0% 80%, 3% 85%, 3% 85%, 10% 85%, 10% 85%, 23% 100%, 23% 100%, 97% 100%, 97% 100%, 100% 97%, 100% 97%, 100% 3%, 100% 3%, 97% 0%, 97% 0%, 3% 0%, 3% 0%);

                ul {
                    font-family: 'FFShamelFamily-Bold';
                    color: $Green;
                    font-size: 14px;
                    line-height: 156%;
                    padding-right: 15px;
                }

                p {
                    color: $White;
                    font-size: 13px;
                    line-height: 180%;
                    text-align: justify;
                    margin-bottom: 0;

                    @include breakpoints(x-small) {
                        font-size: 14px;
                    }

                    @include breakpoints(small) {
                        font-size: 14px;
                    }

                    @include breakpoints(medium) {
                        font-size: 14px;
                    }

                }

            }

        }

    }

}
</style>